import { Button, Form, Input, message } from "antd";
import { useMemo, useState } from "react";
import logo from "../../imgs/home/logo.png";
import styles from "./index.module.scss";
import { useCountDown, useRequest } from "ahooks";
import { getCode, signUp } from "../../api/auth";
/**
 * 注册
 */
export default function SignUp({ onSignIn }) {
  const [form] = Form.useForm();

  const phoneNumber = Form.useWatch("phone", form);

  const [targetDate, setTargetDate] = useState();
  const [isSend, setIsSend] = useState(false);

  const [countDown] = useCountDown({
    targetDate,
    onEnd: () => {
      setIsSend(false);
    },
  });

  // 获取验证码
  const { runAsync: getVerifyCode } = useRequest(getCode, {
    manual: true,
  });

  // 注册
  const { runAsync: onSignUp } = useRequest(signUp, {
    manual: true,
  });

  // 验证码
  const suffixNode = useMemo(() => {
    const isValid = /^1[3456789]\d{9}$/.test(phoneNumber);
    return (
      <div>
        {isSend ? (
          <div className={styles.primary_btn}>
            {Math.round(countDown / 1000)}
          </div>
        ) : (
          <div
            className={styles.primary_btn}
            onClick={async () => {
              if (!phoneNumber) {
                message.error("请输入手机号");
              }
              if (!isValid) return;
              setIsSend(true);
              setTargetDate(Date.now() + 2 * 60 * 1000);
              try {
                await getVerifyCode({ phone: phoneNumber, codeType: "SignUp" });
                message.success("验证码发送成功");
              } catch (error) {
                console.log(error);
                message.error("验证码获取失败");
              }
            }}
          >
            获取验证码
          </div>
        )}
      </div>
    );
  }, [countDown, getVerifyCode, isSend, phoneNumber]);

  const onFinish = async (values) => {
    try {
      await onSignUp(values);
      onSignIn();
      message.success("注册成功");
    } catch (error) {
      message.error(error.message);
    }
  };

  return (
    <div className={styles.sign_up}>
      <img src={logo} alt="" />
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          label="昵称"
          name="nickname"
          layout="vertical"
          rules={[
            {
              required: true,
              message: "请输入您的昵称",
            },
            {
              min: 1,
              max: 20,
              message: "昵称长度不符合要求，需在1-20字符内",
            },
          ]}
        >
          <Input
            placeholder="请输入您的昵称"
            style={{ width: "400px", height: "48px" }}
            showCount
            maxLength={20}
            minLength={1}
          />
        </Form.Item>

        <Form.Item
          label="手机号"
          name="phone"
          layout="vertical"
          required
          rules={[
            {
              required: true,
              message: "请输入您的手机号",
            },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: "手机号格式有误",
            },
          ]}
        >
          <Input
            placeholder="请输入您的手机号"
            style={{ width: "400px", height: "48px" }}
          />
        </Form.Item>

        <Form.Item
          label="验证码"
          layout="vertical"
          name="code"
          rules={[
            {
              required: true,
              message: "请输入验证码",
            },
            {
              pattern: /^\d{6}$/,
              message: "验证码格式有误",
            },
          ]}
        >
          <Input
            placeholder="请输入您的验证码"
            style={{ width: "400px", height: "48px" }}
            suffix={suffixNode}
          />
        </Form.Item>

        <Form.Item
          label="设置密码"
          name="password"
          layout="vertical"
          rules={[
            {
              required: true,
              message: "请输入密码",
            },
            {
              min: 8,
              max: 16,
              message: "密码格式有误，请输入8-16位字符",
            },
          ]}
        >
          <Input.Password
            placeholder="请输入8-16位字符"
            style={{ width: "400px", height: "48px" }}
          />
        </Form.Item>

        <Form.Item
          label="确认密码"
          name="confirmPassword"
          layout="vertical"
          dependencies={["password"]}
          rules={[
            {
              required: true,
              message: "请再次输入密码",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("两次输入的密码不一致!"));
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="请输入8-16位字符"
            style={{ width: "400px", height: "48px" }}
          />
        </Form.Item>

        <Form.Item
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            type="primary"
            style={{ width: "340px", height: "48px", fontSize: "20px" }}
            htmlType="submit"
          >
            注册
          </Button>
        </Form.Item>
      </Form>

      <div style={{ marginTop: "24px" }}>
        已经有账号了？
        <span
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={onSignIn}
        >
          去登录
        </span>
      </div>
    </div>
  );
}
